module.exports = __webpack_public_path__ + "static/media/h_1.f3c73c62.jpg";